import * as types from './types';
import Search from '../queries/search';
import debounceHelper from '../../../helpers/timers/debounce';

export const execute = ({ commit, dispatch, rootState }, { filter, page }) => {
  debounceHelper(() => {
    commit(types.SET_SEARCH_FILTER, filter);
    const projectId = rootState.app.project.id;

    Search.count(filter, projectId, page)
      .then(response => commit(types.SET_COUNT, response.data.posts_by_filter_count));

    Search.search(filter, projectId, page)
      .then(response => dispatch('setResults', response.data.posts_by_filter));
  }, 500);
};

export const nextPage = ({ commit, rootState }, { filter, page }) => {
  const projectId = rootState.app.project.id;

  return Search.search(filter, projectId, page)
    .then(response => commit(types.APPEND_RESULT, response.data.posts_by_filter));
};

export const setResults = ({ commit }, results) => {
  commit(types.SET_SEARCH_RESULTS, results);
};

export const resetSearch = ({ commit, dispatch }) => {
  commit(types.RESET_SEARCH_FILTER);
  commit(types.SET_COUNT, 0);
  dispatch('setResults', []);
};



// WEBPACK FOOTER //
// ./src/screens/Search/store/actions.js